import { Redirect } from 'react-router-dom';

// Mismo mapa que ROLE_SECTIONS en MenuData.js — mantener sincronizados
const ROLE_SECTIONS = {
  'maestro':      ['home', 'imports', 'exports', 'mro', 'dispatches', 'remitos', 'tools', 'appo'],
  'general':      ['home', 'imports', 'exports', 'mro', 'dispatches'],
  'import':       ['home', 'imports', 'appo'],
  'import admin': ['home', 'imports', 'tools', 'appo'],
  'export':       ['home', 'exports'],
  'export admin': ['home', 'exports', 'tools'],
  'mro':          ['home', 'mro'],
  'mro admin':    ['home', 'mro', 'tools'],
  'remitos':      ['home', 'remitos'],
  'appo':        ['home', 'appo'],
};

const getCurrentDatabase = () => {
  try { return localStorage.getItem('currentDatabase') || ''; } catch { return ''; }
};

const getCurrentUserRolMetric = () => {
  try {
    const raw = localStorage.getItem('user');
    if (raw) return JSON.parse(raw)?.rol_metric_name || null;
  } catch { /* ignore */ }
  return null;
};

const getCurrentUserRemitos = () => {
  try {
    const raw = localStorage.getItem('user');
    if (raw) return !!JSON.parse(raw)?.remitos;
  } catch { /* ignore */ }
  return false;
};

/**
 * Protege una ruta según el rol_metric del usuario logueado.
 * Solo aplica cuando la base de datos activa es ssb_internacional (DOW).
 *
 * @param {'imports'|'exports'|'mro'|'dispatches'|'tools'} section
 * @param {React.ReactNode} children
 */
export default function RolMetricProtectedRoute({ section, children }) {
  const isDOW     = getCurrentDatabase() === 'ssb_internacional';
  const rolMetric = getCurrentUserRolMetric();

  // Sin DOW o sin rol asignado → sin restricción
  if (!isDOW || !rolMetric) return children;

  // Si la sección es remitos y el usuario tiene el flag remitos habilitado → permitir
  if (section === 'remitos' && getCurrentUserRemitos()) return children;

  const allowed = ROLE_SECTIONS[rolMetric.toLowerCase()];
  // Rol desconocido → sin restricción
  if (!allowed) return children;

  if (!allowed.includes(section)) {
    return <Redirect to="/" />;
  }

  return children;
}
